import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11'


class ContactInformationEditor extends React.Component {
  render() {
    // ViewModeコンポーネントに、Rails View の 'react_component' タグで引き渡されたデータを渡す
    // （これらのデータは、それぞれのコンポーネントで 'props' 経由でアクセスできる）
    return (
      <ViewMode
        member={this.props.member}
        associations={this.props.associations}
        errors={this.props.errors}
        update_url={this.props.update_url}
        update_login_information_url={this.props.update_login_information_url}
        csrf_token={this.props.csrf_token}
      />
    );
  }
}

class ViewMode extends React.Component {
  // コンストラクタ
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    // デフォルト動作の解除
    e.preventDefault();
    // メッセージエリアをクリア
    var message_area = document.querySelector('div.message_area.profile');
    while (message_area.firstChild) {
      message_area.removeChild(message_area.firstChild);
    }
    // 編集モードに遷移
    ReactDOM.render(
      <EditMode
        member={this.props.member}
        associations={this.props.associations}
        errors={{
          registered_postal_code_1: '',
          registered_postal_code_2: '',
          registered_address: '',
          display_postal_code_1: '',
          display_postal_code_2: '',
          display_address: '',
          cellphone_number: '',
          telephone_number: '',
          fax_number: '',
          public_email: '',
          email: '',
          homepage: ''
        }}
        update_url={this.props.update_url}
        update_login_information_url={this.props.update_login_information_url}
        csrf_token={this.props.csrf_token}
      />,
      document.getElementById('contact_information_area')
    );
  }

  render() {
    function OpenRangeTag(props) {
      if (props.value == 1) {
        return <span className="release_on fs-75">全体に公開</span>
      } else if (props.value == 2) {
        return <span className="release_on fs-75">仲間にのみ公開</span>
      } else if (props.value == 3) {
        return <span className="release_off fs-75">公開しない</span>
      } else {
        return <span className="release_off fs-75"></span>
      }
    }
    function AssociationNameValue(props) {
      var association_name = '';
      props.associations.some(function (value, index) {
        if (value.id == props.association_id) {
          association_name = value.name;
          return true;
        }
      });
      return association_name;
    }
    return (
      <React.Fragment>
        <div className="address">
          <h3 className="fs-113">連絡先情報など</h3>
          <div className="btn_right edit"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>編集する</a></div>
          <table className="edit">
            <tbody>
              <tr>
                <th>所属組合への<br className="pc" />登録住所</th>
                <td>
                  {this.props.member.registered_postal_code_1 ? '〒' + this.props.member.registered_postal_code_1 + '-' + this.props.member.registered_postal_code_2 : ''}<br />
                  <p className="label_registered_address">{this.props.member.registered_address}</p>
                  <p className="font_m right fs-81">※登録住所は公開されません</p>
                </td>
              </tr>
              <tr>
                <th>表示住所</th>
                <td>
                  {this.props.member.display_postal_code_1 ? '〒' + this.props.member.display_postal_code_1 + '-' + this.props.member.display_postal_code_2 : ''}<br />
                  <p className="label_display_address">{this.props.member.display_address}</p>
                  <OpenRangeTag value={this.props.member.display_address_open_range} />
                </td>
              </tr>
              <tr>
                <th>携帯電話番号</th>
                <td>
                  {this.props.member.cellphone_number}
                  <OpenRangeTag value={this.props.member.cellphone_number_open_range} />
                </td>
              </tr>
              <tr>
                <th>電話番号</th>
                <td>
                  {this.props.member.telephone_number}
                  <OpenRangeTag value={this.props.member.telephone_number_open_range} />
                </td>
              </tr>
              <tr>
                <th>FAX番号</th>
                <td>
                  {this.props.member.fax_number}
                  <OpenRangeTag value={this.props.member.fax_number_open_range} />
                </td>
              </tr>
              <tr>
                <th>メールアドレス</th>
                <td>
                  <p className="label_public_email">{this.props.member.public_email}</p>
                  <OpenRangeTag value={this.props.member.public_email_open_range} />
                </td>
              </tr>
              <tr>
                <th>ログインID</th>
                <td>
                  <p className="label_email">{this.props.member.email}</p>
                  <p className="font_m fs-81">※このメールアドレスは公開されません</p>
                  <p className="font_m fs-81">※メールアドレスの変更は<a href={this.props.update_login_information_url}>「ログイン情報の変更」画面</a>にて行ってください。</p>
                </td>
              </tr>
              <tr className="homepage">
                <th>ホームページ</th>
                <td>
                  <p className="label_homepage"><a href={this.props.member.homepage} target="_blank" rel="noopener noreferrer">{this.props.member.homepage}</a></p>
                  <OpenRangeTag value={this.props.member.homepage_open_range} />
                </td>
              </tr>
              <tr>
                <th>所属組合</th>
                <td><AssociationNameValue associations={this.props.associations} association_id={this.props.member.association_id} /></td>
              </tr>
            </tbody>
          </table>
          <h4 className="fs-113 title_bottom">連絡先情報など</h4>
          <div className="btn_right_bottom edit"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>編集する</a></div>
        </div>
      </React.Fragment>
    );
  }
}

class EditMode extends React.Component {
  // コンストラクタ
  constructor(props) {
    super(props);
    this.state = { member: JSON.parse(JSON.stringify(this.props.member)) };
    this.resetParameter(this.state.member);
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  // 初期化が必要なパラメータのリセット
  resetParameter(member) {
    var cellphone_number = member.cellphone_number.split('-');
    member.cellphone_number_1 = cellphone_number[0];
    member.cellphone_number_2 = cellphone_number[1];
    member.cellphone_number_3 = cellphone_number[2];
    var telephone_number = member.telephone_number.split('-');
    member.telephone_number_1 = telephone_number[0];
    member.telephone_number_2 = telephone_number[1];
    member.telephone_number_3 = telephone_number[2];
    var fax_number = member.fax_number.split('-');
    member.fax_number_1 = fax_number[0];
    member.fax_number_2 = fax_number[1];
    member.fax_number_3 = fax_number[2];
    member.display_address_open_range = member.display_address_open_range ? member.display_address_open_range : "1"
    member.telephone_number_open_range = member.telephone_number_open_range ? member.telephone_number_open_range : "1"
    member.cellphone_number_open_range = member.cellphone_number_open_range ? member.cellphone_number_open_range : "1"
    member.fax_number_open_range = member.fax_number_open_range ? member.fax_number_open_range : "1"
    member.mail_address_open_range = member.mail_address_open_range ? member.mail_address_open_range : "3"
    member.public_email_open_range = member.public_email_open_range ? member.public_email_open_range : "1"
    member.homepage_open_range = member.homepage_open_range ? member.homepage_open_range : "1"
  }

  handleClick(e) {
    // デフォルト動作の解除
    e.preventDefault();
    // 「プロフィール公開範囲」の設定
    var profile_open_range = 3; // 3:「公開しない」
    if (this.state.member.display_address_open_range == 2 || this.state.member.cellphone_number_open_range == 2 || this.state.member.telephone_number_open_range == 2 || this.state.member.fax_number_open_range == 2 || this.state.member.public_email_open_range == 2 || this.state.member.homepage_open_range == 2) {
      profile_open_range = 2;   // 2:「仲間にのみ公開」
    }
    if (this.state.member.display_address_open_range == 1 || this.state.member.cellphone_number_open_range == 1 || this.state.member.telephone_number_open_range == 1 || this.state.member.fax_number_open_range == 1 || this.state.member.public_email_open_range == 1 || this.state.member.homepage_open_range == 1) {
      profile_open_range = 1;   // 1:「全体に公開する」
    }
    // ボタン非活性
    let elements = document.querySelectorAll('.btn_target');
    elements.forEach(function (element) {
      element.classList.add('btn_disabled');
    });
    // membersの更新
    fetch(this.props.update_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.props.csrf_token
      },
      body: JSON.stringify({
        member: {
          display_postal_code_1: this.state.member.display_postal_code_1,
          display_postal_code_2: this.state.member.display_postal_code_2,
          display_address: this.state.member.display_address,
          display_address_open_range: this.state.member.display_address_open_range,
          cellphone_number: this.state.member.cellphone_number,
          cellphone_number_open_range: this.state.member.cellphone_number_open_range,
          telephone_number: this.state.member.telephone_number,
          telephone_number_open_range: this.state.member.telephone_number_open_range,
          fax_number: this.state.member.fax_number,
          fax_number_open_range: this.state.member.fax_number_open_range,
          public_email: this.state.member.public_email,
          public_email_open_range: this.state.member.public_email_open_range,
          homepage: this.state.member.homepage,
          homepage_open_range: this.state.member.homepage_open_range,
          profile_open_range: profile_open_range
        },
        authenticity_token: this.props.csrf_token
      })
    }).then((res) => {
      return res.json();
    }).then((data) => {
      // メッセージエリアをクリア
      var message_area = document.querySelector('div.message_area.profile');
      while (message_area.firstChild) {
        message_area.removeChild(message_area.firstChild);
      }
      if (data.status == 200) {
        // ViewModeを再表示
        ReactDOM.render(
          <ViewMode
            member={this.state.member}
            associations={this.props.associations}
            errors={this.props.errors}
            update_url={this.props.update_url}
            update_login_information_url={this.props.update_login_information_url}
            csrf_token={this.props.csrf_token}
          />,
          document.getElementById('contact_information_area')
        );
        // 変更された項目があるとき
        if (Object.keys(data.saved_changes).length !== 0) {
          // 更新メッセージ表示
          const node = document.createElement('p');
          const message = document.createTextNode('プロフィールを更新しました。');
          node.appendChild(message);
          document.querySelector('div.message_area.profile').appendChild(node);
          // 「プロフィール完成度」を更新
          if (data.saved_changes.profile_completeness) {
            $('div.chart_area dl dd.chart p span').css('display', 'none');
            $('div.chart_area dl dd.chart p').css('width', '0px');
            $('div.chart_area dl dd.chart p').animate({ width: data.saved_changes.profile_completeness[1] + '%' }, 1000, 'swing', function () { $('div.chart_area dl dd.chart p span').css('display', 'block') });
            $('div.chart_area dl dd.chart p span b').text(data.saved_changes.profile_completeness[1]);
          }
        }
      } else if (data.status == 400) {
        // EditModeを再表示
        ReactDOM.render(
          <EditMode
            member={JSON.parse(JSON.stringify(this.state.member))}
            associations={this.props.associations}
            errors={data.errors}
            update_url={this.props.update_url}
            update_login_information_url={this.props.update_login_information_url}
            csrf_token={this.props.csrf_token}
          />,
          document.getElementById('contact_information_area')
        );
        // エラーメッセージ表示
        const node = document.createElement('p');
        const message = document.createTextNode('入力内容にエラーがあります。');
        node.appendChild(message);
        document.querySelector('div.message_area.profile').appendChild(node);
      }
      // ボタン活性
      let elements = document.querySelectorAll('.btn_target');
      elements.forEach(function (element) {
        element.classList.remove('btn_disabled');
      });
    }).catch((err) => {
      console.error(err);
    });
  }

  handleChange(e) {
    var member = this.state.member;
    switch (e.target.id) {
      case 'registered_postal_code_1':
        member.registered_postal_code_1 = e.target.value;
        break;
      case 'registered_postal_code_2':
        member.registered_postal_code_2 = e.target.value;
        break;
      case 'registered_address':
        member.registered_address = e.target.value;
        break;
      case 'display_postal_code_1':
        member.display_postal_code_1 = e.target.value;
        break;
      case 'display_postal_code_2':
        member.display_postal_code_2 = e.target.value;
        break;
      case 'display_address':
        member.display_address = e.target.value;
        break;
      case 'display_address_open_range':
        member.display_address_open_range = e.target.value;
        break;
      case 'cellphone_number_1':
        member.cellphone_number_1 = e.target.value;
        member.cellphone_number = member.cellphone_number_1 + '-' + member.cellphone_number_2 + '-' + member.cellphone_number_3;
        break;
      case 'cellphone_number_2':
        member.cellphone_number_2 = e.target.value;
        member.cellphone_number = member.cellphone_number_1 + '-' + member.cellphone_number_2 + '-' + member.cellphone_number_3;
        break;
      case 'cellphone_number_3':
        member.cellphone_number_3 = e.target.value;
        member.cellphone_number = member.cellphone_number_1 + '-' + member.cellphone_number_2 + '-' + member.cellphone_number_3;
        break;
      case 'cellphone_number_open_range':
        member.cellphone_number_open_range = e.target.value;
        break;
      case 'telephone_number_1':
        member.telephone_number_1 = e.target.value;
        member.telephone_number = member.telephone_number_1 + '-' + member.telephone_number_2 + '-' + member.telephone_number_3;
        break;
      case 'telephone_number_2':
        member.telephone_number_2 = e.target.value;
        member.telephone_number = member.telephone_number_1 + '-' + member.telephone_number_2 + '-' + member.telephone_number_3;
        break;
      case 'telephone_number_3':
        member.telephone_number_3 = e.target.value;
        member.telephone_number = member.telephone_number_1 + '-' + member.telephone_number_2 + '-' + member.telephone_number_3;
        break;
      case 'telephone_number_open_range':
        member.telephone_number_open_range = e.target.value;
        break;
      case 'fax_number_1':
        member.fax_number_1 = e.target.value;
        member.fax_number = member.fax_number_1 + '-' + member.fax_number_2 + '-' + member.fax_number_3;
        break;
      case 'fax_number_2':
        member.fax_number_2 = e.target.value;
        member.fax_number = member.fax_number_1 + '-' + member.fax_number_2 + '-' + member.fax_number_3;
        break;
      case 'fax_number_3':
        member.fax_number_3 = e.target.value;
        member.fax_number = member.fax_number_1 + '-' + member.fax_number_2 + '-' + member.fax_number_3;
        break;
      case 'fax_number_open_range':
        member.fax_number_open_range = e.target.value;
        break;
      case 'public_email':
        member.public_email = e.target.value;
        break;
      case 'public_email_open_range':
        member.public_email_open_range = e.target.value;
        break;
      case 'homepage':
        member.homepage = e.target.value;
        break;
      case 'homepage_open_range':
        member.homepage_open_range = e.target.value;
    }
    // 状態を更新
    this.setState({ member: member });
  }

  handleClickLink(e) {
    e.preventDefault();
  }

  render() {
    function ErrorMessageTag(props) {
      if (props.item == '全体' && props.message) {
        return <div className="error_massage none_markup">エラー項目があります。</div>;
      } else if (props.item && props.message) {
        return <div className="error_massage">{props.item}{props.message}</div>;
      } else if (props.message) {
        return <div className="error_massage">{props.message}</div>;
      } else {
        return '';
      }
    }
    function AssociationNameValue(props) {
      var association_name = '';
      props.associations.some(function (value, index) {
        if (value.id == props.association_id) {
          association_name = value.name;
          return true;
        }
      });
      return association_name;
    }
    return (
      <React.Fragment>
        <div className="address input_group_area">
          <h3 className="fs-113">連絡先情報など</h3>
          <div className="btn_right"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>更新</a></div>
          <ErrorMessageTag item={'全体'} message={this.props.errors ? Object.values(this.props.errors).join('') : ''} />
          <table className="edit">
            <tbody>
              <tr>
                <th>所属組合への<br className="pc" />登録住所</th>
                <td>
                  {this.state.member.registered_postal_code_1 ? '〒' + this.state.member.registered_postal_code_1 + '-' + this.state.member.registered_postal_code_2 : ''}<br />
                  {this.state.member.registered_address}
                  <p className="font_m right fs-81">※登録住所は公開されません</p>
                </td>
              </tr>
              <tr>
                <th>表示住所</th>
                <td>
                  <ErrorMessageTag item={'郵便番号'} message={this.props.errors.display_postal_code_1 ? this.props.errors.display_postal_code_1 : this.props.errors.display_postal_code_2 ? this.props.errors.display_postal_code_2 : ''} />
                  <input id="display_postal_code_1" type="text" maxLength="3" value={this.state.member.display_postal_code_1} onChange={this.handleChange} className={this.props.member.display_postal_code_1 ? "w15 completed postalcode" : "w15 postalcode"} />-
                  <input id="display_postal_code_2" type="text" maxLength="4" value={this.state.member.display_postal_code_2} onChange={this.handleChange} className={this.props.member.display_postal_code_2 ? "w20 completed postalcode2" : "w20 postalcode2"} /><br />
                  <ErrorMessageTag item={'表示住所'} message={this.props.errors.display_address} />
                  <input id="display_address" type="text" maxLength="100" value={this.state.member.display_address} onChange={this.handleChange} className={this.props.member.display_address ? "w50 completed" : "w50"} />
                  <select id="display_address_open_range" value={this.state.member.display_address_open_range} onChange={this.handleChange} className={this.props.member.display_address_open_range ? "open_range completed" : "open_range"}>
                    <option value="1">全体に公開する</option>
                    <option value="2">仲間にのみ公開</option>
                    <option value="3">公開しない</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>携帯電話番号</th>
                <td>
                  <ErrorMessageTag item={'携帯電話番号'} message={this.props.errors.cellphone_number} />
                  <input id="cellphone_number_1" type="text" maxLength="3" value={this.state.member.cellphone_number_1} onChange={this.handleChange} className={this.props.member.cellphone_number ? "w15 completed telephone" : "w15 telephone"} />-
                  <input id="cellphone_number_2" type="text" maxLength="4" value={this.state.member.cellphone_number_2} onChange={this.handleChange} className={this.props.member.cellphone_number ? "w15 completed telephone2" : "w15 telephone2"} />-
                  <input id="cellphone_number_3" type="text" maxLength="4" value={this.state.member.cellphone_number_3} onChange={this.handleChange} className={this.props.member.cellphone_number ? "w15 completed telephone3" : "w15 telephone3"} />
                  <select id="cellphone_number_open_range" value={this.state.member.cellphone_number_open_range} onChange={this.handleChange} className={this.props.member.cellphone_number_open_range ? "open_range completed" : "open_range"}>
                    <option value="1">全体に公開する</option>
                    <option value="2">仲間にのみ公開</option>
                    <option value="3">公開しない</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th> 電話番号</th>
                <td>
                  <ErrorMessageTag item={'電話番号'} message={this.props.errors.telephone_number} />
                  <input id="telephone_number_1" type="text" maxLength="5" value={this.state.member.telephone_number_1} onChange={this.handleChange} className={this.props.member.telephone_number ? "w15 completed telephone" : "w15 telephone"} />-
                  <input id="telephone_number_2" type="text" maxLength="4" value={this.state.member.telephone_number_2} onChange={this.handleChange} className={this.props.member.telephone_number ? "w15 completed telephone2" : "w15 telephone2"} />-
                  <input id="telephone_number_3" type="text" maxLength="4" value={this.state.member.telephone_number_3} onChange={this.handleChange} className={this.props.member.telephone_number ? "w15 completed telephone3" : "w15 telephone3"} />
                  <select id="telephone_number_open_range" value={this.state.member.telephone_number_open_range} onChange={this.handleChange} className={this.props.member.telephone_number_open_range ? "open_range completed" : "open_range"}>
                    <option value="1">全体に公開する</option>
                    <option value="2">仲間にのみ公開</option>
                    <option value="3">公開しない</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>FAX番号</th>
                <td>
                  <ErrorMessageTag item={'FAX番号'} message={this.props.errors.fax_number} />
                  <input id="fax_number_1" type="text" maxLength="5" value={this.state.member.fax_number_1} onChange={this.handleChange} className={this.props.member.fax_number ? "w15 completed telephone" : "w15 telephone"} />-
                  <input id="fax_number_2" type="text" maxLength="4" value={this.state.member.fax_number_2} onChange={this.handleChange} className={this.props.member.fax_number ? "w15 completed telephone2" : "w15 telephone2"} />-
                  <input id="fax_number_3" type="text" maxLength="4" value={this.state.member.fax_number_3} onChange={this.handleChange} className={this.props.member.fax_number ? "w15 completed telephone3" : "w15 telephone3"} />
                  <select id="fax_number_open_range" value={this.state.member.fax_number_open_range} onChange={this.handleChange} className={this.props.member.fax_number_open_range ? "open_range completed" : "open_range"}>
                    <option value="1">全体に公開する</option>
                    <option value="2">仲間にのみ公開</option>
                    <option value="3">公開しない</option>
                  </select>
                </td>
              </tr>
              <tr className="public_email">
                <th>メールアドレス</th>
                <td>
                  <ErrorMessageTag item={'メールアドレス'} message={this.props.errors.public_email} />
                  <input id="public_email" type="text" maxLength="255" value={this.state.member.public_email} onChange={this.handleChange} className={this.props.member.public_email ? "w50 completed" : "w50"} />
                  <select id="public_email_open_range" value={this.state.member.public_email_open_range} onChange={this.handleChange} className={this.props.member.public_email_open_range ? "open_range completed" : "open_range"}>
                    <option value="1">全体に公開する</option>
                    <option value="2">仲間にのみ公開</option>
                    <option value="3">公開しない</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>ログインID</th>
                <td>
                  <p className="label_email">{this.props.member.email}</p>
                  <p className="font_m fs-81">※このメールアドレスは公開されません</p>
                  <p className="font_m fs-81 email_notice">※ログインIDの変更は<a href={this.props.update_login_information_url}>「ログイン情報の変更」画面</a>にて行ってください。</p>
                </td>
              </tr>
              <tr className="homepage">
                <th>ホームページ</th>
                <td>
                  <ErrorMessageTag item={'ホームページ'} message={this.props.errors.homepage} />
                  <input id="homepage" type="text" maxLength="1024" value={this.state.member.homepage} onChange={this.handleChange} className={this.props.member.homepage ? "w50 completed" : "w50"} />
                  <select id="homepage_open_range" value={this.state.member.homepage_open_range} onChange={this.handleChange} className={this.props.member.homepage_open_range ? "open_range completed" : "open_range"}>
                    <option value="1">全体に公開する</option>
                    <option value="2">仲間にのみ公開</option>
                    <option value="3">公開しない</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>所属組合</th>
                <td><AssociationNameValue associations={this.props.associations} association_id={this.props.member.association_id} /></td>
              </tr>
            </tbody>
          </table>
          <h4 className="fs-113 title_bottom">連絡先情報など</h4>
          <div className="btn_right_bottom"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>更新</a></div>
        </div>
      </React.Fragment>
    );
  }
}

ContactInformationEditor.propTypes = { member: PropTypes.object }

export default ContactInformationEditor
